export default {
    invalid_type: {
        email: "อีเมลของคุณไม่ถูกต้อง กรุณากรอกใหม่",
    },
    correct_url: "Url ของคุณไม่ถูกต้องกรุรณากรอกใหม่",
    field_required: "กรุณากรอกข้อมูลในช่องนี้!",
    email_invalid: "รูปแบบอีเมลไม่ถูกต้อง",
    required: "{{name}} จำเป็นต้องกรอกข้อมูลนี้",
    pass_not_confirm: "ยืนยันรหัสผ่านไม่ถูกต้อง กรุณากรอกใหม่",
    max_length: "{{name}} จำเป็นต้องมีความยาวที่น้อยกว่า 255 ตัวอักษร",
    max_length_number: "{{name}} จำเป็นต้องมีความยาวไม่เกิน {{number}} ตัวอักษร",
    password_must_match: "รหัสผ่านของคุณไม่ตรงกัน กรุณากรอกใหม่",
    min: "{{name}} จำเป็นต้องมีความยาวอย่างน้อย {{number}} ตัวอักษร ",
    max: "{{name}} จำเป็นต้องมีความยาวไม่เกิน {{number}} ตัวอักษร",
    max_number: "{{name}} จำเป็นต้องเป็นจำนวนน้อยกว่าหรือเท่ากับ {{number}}",
    min_number: "{{name}} จำเป็นต้องมีจำนวนมากกว่าหรือเท่ากับ {{number}}",
    must_number: "{{name}} จำเป็นต้องเป็นตัวเลข",
    date_before_now: "{{name}} ควรเกิดขึ้นก่อนวันนี้",
    date_now: "วันที่ ควรจะเป็นวันที่หลังจาก วันที่กรอกปัจจุบัน",
    date_from: "วันที่ ควรจะเป็นวันที่หลังจาก วันที่เริ่มต้น",
    is_Number: "จำเป็นต้องเป็นตัวเลข",
    must_be_a_valid_data_URL: "Url ของคุณไม่ถูกต้องกรุณากรอกใหม่",
    please_enter_website: "กรุณาเข้าสู่หน้าเว็บไซต์",
    image: {
        wrong_type: "รูปภาพจำเป็นต้องมีสกุลไฟล์ png, jpg, และ jpeg",
        empty: "ไม่ค้นพบรูปภาพ",
        max_size: "รูปภาพไม่ควรมีขนาดเกิน 10MB",
        not_svg: "รูปภาพจำเป็นต้องมีสกุลไฟล์ svg",
    },
    password_require: "ต้องการรหัสผ่าน",
};
